import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.css';

export const choicesInstances = new Map();

export default function initCustomSelects() {
    const selects = document.querySelectorAll('.js-select');

    selects.forEach(select => {
        if (choicesInstances.has(select)) return;

        const instance = new Choices(select, {
            searchEnabled: false,
            itemSelectText: '',
            shouldSort: false
        });

        choicesInstances.set(select, instance);

        const selectedValue = select.value;
        const dropdownItems = select.closest('.choices')?.querySelectorAll('[data-choice]') || [];

        dropdownItems.forEach(el => {
            const isSelected = el.getAttribute('data-value') === selectedValue;
            el.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            el.classList.toggle('is-highlighted', isSelected);
        });
    });
}
